"use strict";

module.exports = ["features", "warnings", "assemblyPieces", "lineageAnnotations", "parts", "cutsites", "orfs", "translations", "primers", "guides"];
module.exports.modifiableTypes = ["features", "assemblyPieces", "lineageAnnotations", "warnings", "parts", "translations", "primers", "guides"];